/* Homepage loose-diamond cards: two option selects update title, price and link. */
(() => {
  const caratValue = (text) => parseFloat(String(text).replace(/[^0-9.]/g, '')) || 0;

  const setupCard = (card) => {
    let variants = [];
    try { variants = JSON.parse(card.querySelector('[data-card-variants]').textContent); } catch (e) { return; }
    const qSelect = card.querySelector('[data-card-quality]');
    const cSelect = card.querySelector('[data-card-carat]');
    if (!qSelect || !cSelect) return;

    // Carat options in numeric order.
    const current = cSelect.value;
    [...cSelect.options]
      .sort((a, b) => caratValue(a.value) - caratValue(b.value))
      .forEach((o) => cSelect.appendChild(o));
    cSelect.value = current;

    const productTitle = card.dataset.productTitle || '';
    const titleLink = card.querySelector('[data-card-title]');
    const priceNode = card.querySelector('[data-card-price]');
    const find = (q, c) => variants.find((v) => v.quality === q && v.carat === c && v.available);

    const render = () => {
      [...qSelect.options].forEach((o) => { o.disabled = !variants.some((x) => x.quality === o.value && x.available); });
      [...cSelect.options].forEach((o) => { o.disabled = !find(qSelect.value, o.value); });
      let v = find(qSelect.value, cSelect.value);
      if (!v) {
        const target = caratValue(cSelect.value);
        v = variants
          .filter((x) => x.quality === qSelect.value && x.available)
          .sort((a, b) => Math.abs(caratValue(a.carat) - target) - Math.abs(caratValue(b.carat) - target))[0];
        if (!v) return;
        cSelect.value = v.carat;
      }
      const [color, clarity] = v.quality.split(' / ');
      if (titleLink) titleLink.textContent = `${v.carat} ${productTitle} — ${color} Color, ${clarity} Clarity`;
      if (priceNode) priceNode.textContent = v.price;
      card.querySelectorAll('[data-card-link]').forEach((a) => { a.href = v.url; });
    };

    qSelect.addEventListener('change', render);
    cSelect.addEventListener('change', render);
    render();
  };

  const init = () => {
    document.querySelectorAll('[data-ts-showcase-root] [data-showcase-card]').forEach((card) => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      setupCard(card);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
